module.exports = __webpack_public_path__ + "static/media/close.af4bfa84.svg";